import {initialize} from 'linksoft';

import './api';
import './buttons';
import './editor';
import initializer from './initializer';

// auto-register initializer on import
initialize.register(initializer);


export columnTypes, {registerRenderer as addColumnType, createRenderer as createColumn }  from './renderers';
export createTable from './create';
export {addTemplates} from './templates';
export function addTemplate(name, template) {
    const container = {};
    container[name] = template;
    addTemplates(container);
}
export {addCallback, addCallbacks} from './callbacks';



// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/main.js